<template>
    <div class="sustainable-component wage-money-base-salary">

        <!--<div class="bg-success mb-3 p-3 rounded">vue component wage-money-base-salary</div>-->

        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12 col-md-6 mb-5">
                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="doUpdate">
                        Uppdatera löneunderlag
                    </v-btn>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <a href="javascript:void(0)" @click="printBaseSalary">Visa översikt över grundlöner</a>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-12">
                    <v-radio-group v-bind:disabled="disabled" v-model="calculationType">
                        <v-radio @click="changeType($event,'0')" label="Alt 1. Faställa grundlön utan arbetsvärdering." value="0"></v-radio>
                        <v-radio @click="changeType($event,'1')" label="Alt 2. Grundlönen baseras på arbetsvärdering och poängintervall." value="1"></v-radio>
                        <v-radio @click="changeType($event,'2')" label="Alt 3. Grundlönen baseras på arbetsvärdering och kronor per poäng." value="2"></v-radio>
                    </v-radio-group>
                </div>
            </div>
            <div class="row" v-if="calculationType == '1'">
                <div class="col-12 col-md-6 mr-3">
                    <CommonLabelContainer title="Konstruktion">
                        <v-form v-model="valid" ref="form">
                            <div class="container-fluid p-0">
                                <div class="row">
                                    <div class="col-12">
                                        <v-text-field v-bind:disabled="disabled" bg-color="white" :rules="[rules.integer]" label="Poäng fr.o.m" v-model="startPoint" variant="outlined"></v-text-field>
                                    </div>
                                    <div class="col-12">
                                        <v-text-field v-bind:disabled="disabled" bg-color="white" :rules="[rules.positiveInteger]" label="Poäng t.o.m" v-model="endPoint" variant="outlined"></v-text-field>
                                    </div>
                                    <div class="col-12">
                                        <v-text-field :decimal-sv="true" v-bind:disabled="disabled" bg-color="white" :rules="[rules.float]" label="Grundlön kr" v-model="baseSalary" variant="outlined"></v-text-field>
                                    </div>
                                    <div class="col-12">

                                        <table class="table table-light table-hover table-striped">
                                            <thead>
                                                <tr>
                                                    <th class="col-3">Poäng fr.o.m.</th>
                                                    <th class="col-3">Poäng t.o.m.</th>
                                                    <th class="col-3">Grundlön kr</th>
                                                    <th class="col-3"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(interval, index) in salaryIntervals" :key="index">
                                                    <td>{{interval.From}}</td>
                                                    <td>{{interval.To}}</td>
                                                    <td><span v-decimal-text.max2="interval.Salary"></span></td>
                                                    <td>
                                                        <div class="pull-right" style="" v-if="disabled == false">
                                                            <div class="dropdown text-right pr-2">
                                                                <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    ...
                                                                </a>
                                                                <div class="dropdown-menu dropdown-menu-right">
                                                                    <a href="javascript:void(0)" class="dropdown-item" @click="updateInterval(interval)">Ändra</a>
                                                                    <a href="javascript:void(0)" class="dropdown-item" @click="removeSalaryInterval(interval)">Ta bort</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="col-12">
                                        <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="addSalaryInterval">
                                            Spara intervall
                                        </v-btn>
                                    </div>
                                </div>
                            </div>
                        </v-form>
                    </CommonLabelContainer>
                </div>
            </div>
            <div class="row" v-if="calculationType == '2'">
                <div class="col-12 col-md-6 mr-3">
                    <CommonLabelContainer title="Konstruktion">
                        <v-form v-model="valid" ref="form2">
                            <div class="container-fluid p-0">
                                <div class="row">
                                    <div class="col-12 col-md-6 mr-3">
                                        <v-text-field :decimal-sv="true" v-bind:disabled="disabled" bg-color="white" :rules="[rules.float]" label="Grundlön per poäng" v-model="salaryPerPoint" variant="outlined"></v-text-field>
                                    </div>
                                    <div class="col-12 col-md-6 mr-3">
                                        <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="updateSalariesWithPoint">
                                            Beräkna lön
                                        </v-btn>
                                    </div>
                                </div>
                            </div>
                        </v-form>
                    </CommonLabelContainer>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 mr-3 mt-3">
                    <b>Utfall</b>
                    <table class="mt-2 table table-light table-hover table-striped">
                        <thead>
                            <tr>
                                <th class="col-6">Befattning</th>
                                <th class="col-2">Poäng</th>
                                <th class="col-4">Grundlön kr</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(position, index) in positions" :key="index">
                                <td>{{position.Name}}</td>
                                <td>{{position.Points}}</td>
                                <td v-if="calculationType == '0'">
                                    <v-text-field :decimal-sv="true" v-bind:disabled="disabled" bg-color="white" v-model="position.BaseSalary" hide-details="true" density="compact" variant="outlined"></v-text-field>
                                </td>
                                <td v-else><span v-decimal-text.max2="position.BaseSalary"></span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12 col-md-6 mr-3 mt-3" v-if="calculationType == '0'">
                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="setAllSalaries">
                        Skapa grundlön i systemet
                    </v-btn>
                </div>
            </div>
        </div>
        <WageSalaryInterval v-bind:disabled="disabled" :model="model" ref="updateSalaryInterval" @updated="updateAfterChange"></WageSalaryInterval>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    import WageService from "../../Services/WageService";
    import ValidationService from "../../Services/ValidationService";
    import { getCurrentInstance } from 'vue'
    import CommonLabelContainer from "../../common/common-label-container";
    import WageSalaryInterval from './update/update-salary-interval.vue'
    import CommonSpinner from '../../common/common-spinner.vue'
    import { ref } from 'vue'

    const updateSalaryInterval = ref(null);
    const form = ref(null);
    const form2 = ref(null);

    export default {
        emits: ['updated'],
        name: 'wage-money-base-salary',
        components: {
            CommonLabelContainer,
            WageSalaryInterval,
            CommonSpinner,
        },
        props: {
            model: Object,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            async changeType(event, type) {
                event.preventDefault();
                if (confirm("Om du byter alternativ kommer befintliga grundlöner att nollställas. Vill du byta alternativ?")) {
                    this.calculationType = type
                    this.loading++;
                    try {
                        await WageService.updateBaseWagepart(true, this.calculationType, this.salaryPerPoint);
                        this.displaySnackBar("Sparat");
                        if (this.calculationType == '1') {
                            this.loadIntervals()
                        }
                        this.getPositionsWithPoints();
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            async updateSalariesWithPoint() {
                var result = await this.form2.validate();
                if (result.valid != true)
                    return;
                this.loading++;
                try {
                    await WageService.updateBaseWagepart(false, this.calculationType, this.salaryPerPoint)
                    this.displaySnackBar("Sparat");
                    this.getPositionsWithPoints();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async setAllSalaries() {
                this.loading++;
                try {
                    await WageService.updateBaseSalaries(this.positions);
                    this.displaySnackBar("Sparat");
                    this.updateAfterChange()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async addSalaryInterval() {
                this.loading++;
                var result = await this.form.validate();
                if (result.valid != true)
                    return;
                try {
                    await WageService.addSalaryInterval(this.startPoint, this.endPoint, this.baseSalary);
                    this.displaySnackBar("Sparat");
                    this.updateAfterChange()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            updateInterval(item) {
                this.loading++;
                this.updateSalaryInterval.open(item);
                this.loading--;
            },
            async removeSalaryInterval(item) {
                if (confirm(" Är du säker att du vill radera intervallet?")) {
                    this.loading++;
                    try {
                        await WageService.deleteSalaryInterval(item.SalaryIntervalId);
                        this.displaySnackBar("Borttaget");
                        this.updateAfterChange()
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            async updateAfterChange() {
                this.loading++;
                try {
                    await WageService.updateBaseWagepart(false, this.calculationType, this.salaryPerPoint);
                    if (this.calculationType == '1') {
                        this.loadIntervals();
                    }
                    this.getPositionsWithPoints();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadIntervals() {
                this.loading++;
                try {
                    this.salaryIntervals = await WageService.getSalaryInterval(0);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async getSalaryPart() {
                this.loading++;
                try {
                    var salaryPart = await WageService.getWagePartBase();
                    this.salaryPerPoint = salaryPart.SalaryPerPoint;
                    this.calculationType = salaryPart.CalculationType.toString();
                    this.loadIntervals()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async getPositionsWithPoints() {
                this.loading++;
                try {
                    this.positions = await WageService.getPositionsWithPoints();
                    if (this.positions.length > 0) {
                        this.selectedPosition = this.positions[0].JobPositionId;
                    }
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async printBaseSalary() {
                this.newWindow = window.open('/wagesettingsprint/PrintBaseSalary', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            async doUpdate() {
                this.loading++;
                try {
                    await this.updateAfterChange();
                    this.displaySnackBar("Uppdaterat");
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                valid: false,
                rules: ValidationService.rules(),
                salaryIntervals:[],
                salaryPerPoint: null,
                startPoint: null,
                endPoint: null,
                baseSalary: null,
                calculationType: "0",
                positions: [],
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {

        },
        mounted() {
            this.getSalaryPart();
            this.getPositionsWithPoints();
        },

        // eslint-disable-next-line
        setup(props, { emit }) {
            return { updateSalaryInterval, form, form2 }
        }

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
